export interface SiteFeaturesJson {
    api_tokens: {
        enabled: boolean
    }
    broadcasting: {
        enabled: boolean
    },
    schedules: {
        enabled: boolean
    },
    department_site_hierarchy?: {
        enabled: boolean | null
    },
    time_off?: {
        enabled: boolean
    }
}

export class SiteFeatures {
    apiTokensEnabled: boolean
    broadcastingEnabled: boolean
    schedulesEnabled: boolean
    departmentSiteHierarchyEnabled: boolean
    timeOffEnabled: boolean

    constructor (
        apiTokensEnabled: boolean,
        broadcastingEnabled: boolean,
        schedulesEnabled: boolean,
        departmentSiteHierarchyEnabled: boolean,
        timeOffEnabled: boolean,
    ) {
        this.apiTokensEnabled = apiTokensEnabled
        this.broadcastingEnabled = broadcastingEnabled
        this.schedulesEnabled = schedulesEnabled
        this.departmentSiteHierarchyEnabled = departmentSiteHierarchyEnabled
        this.timeOffEnabled = timeOffEnabled
    }

    static fromJson(json: SiteFeaturesJson): SiteFeatures {
        return new SiteFeatures(
            json.api_tokens.enabled,
            json.broadcasting.enabled,
            json.schedules.enabled,
            json.department_site_hierarchy?.enabled ?? true,
            json.time_off?.enabled ?? false,
        )
    }
}
